import { AxiosResponse } from 'axios';
import { useState } from 'react';

import { IAxiosResponse, IError } from 'types';

const useAxios = <T>() => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AxiosResponse<IError, IError> | null>();
  const [result, setResult] = useState<AxiosResponse<IError, IError> | T>();

  const request = async (
    call: Promise<T | AxiosResponse<IError, IError>>
  ): Promise<T | AxiosResponse<IError, IError>> => {
    let response: T | AxiosResponse<IError, IError>;
    setLoading(true);
    try {
      response = (await call) as T;

      setError(null);
    } catch (errorResponse) {
      setError(errorResponse as AxiosResponse<IError, IError>);
      response = errorResponse as AxiosResponse<IError, IError>;
    }

    setResult(response);
    setLoading(false);
    return response;
  };

  return <
    [
      (call: Promise<T | AxiosResponse<IError, IError>>) => Promise<T | AxiosResponse<IError, IError>>,
      IAxiosResponse<T>
    ]
  >[request, { loading, error, data: result }];
};

export default useAxios;
